import { createContext } from "react";

export const ActiveSectionContext= createContext('about');
